// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ZH2CC","label":"CategoryService_label__2U5Ek","location":"CategoryService_location__3I1Dq"};